import { ToggleButtonsController, InputBase } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";
import { Objects } from "@salaxy/core";

/**
 * The ToggleButtons component provides a set of toggle buttons bound to a model.
 * For each given value string, a unique toggle button is created. Wraps them all inside a group element.
 * Type can be "block", "row" or "inline". Each is styled differently.
 * @example
 * ```html
 * <salaxy-toggle-buttons name="myToggleButtonsGroup" ng-model="$ctrl.view" options="[{ value: 'test1', label: 'Test1' }, { value: 'test2', label: 'Test2' }]" type="block"></salaxy-toggle-buttons>
 * ```
 */
export class ToggleButtons extends ComponentBase {
  public require = {
    model: "ngModel"
  };

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = Objects.extend(InputBase.crudBindings, {
    /** The options to be displayed in the toggle buttons. For each given value, a new button is created. */
    options: "<",

    /** Display type of toggle buttons: "row", "inline" or "block" */
    type: "@",

    /** Type "row" toggle button has an image on top of the the text. */
    imgSrc: "@",
  });

  /** Uses the ToggleButtonsController */
  public controller = ToggleButtonsController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/form-controls/ToggleButtons.html";
}